function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "padlock"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m18 13h-1v-6c0-2.757-2.243-5-5-5s-5 2.243-5 5v6h-1c-1.103 0-2 .897-2 2v5c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-5c0-1.103-.897-2-2-2zm-9-6c0-1.654 1.346-3 3-3s3 1.346 3 3v6h-6zm8.997 13h-11.997v-5h12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12 16c-.553 0-1 .447-1 1v1c0 .553.447 1 1 1s1-.447 1-1v-1c0-.553-.447-1-1-1z"
})));

var Svg087Padlock = function Svg087Padlock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg087Padlock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/087-padlock.857ce7fa.svg";
export { ForwardRef as ReactComponent };